module.exports = __webpack_public_path__ + "img/yishi4.aab1aa02.jpg";